import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import {
  APP_INITIALIZER,
  CUSTOM_ELEMENTS_SCHEMA,
  ErrorHandler,
  NgModule,
} from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import * as Sentry from '@sentry/angular';
import { LmsApi } from '@services/_api/lms-api';
import { AccountSelectorService } from '@services/account-selector.service';
import {
  DialogService,
  EnvConfigurationService,
  HttpSpinnerComponent,
  ToastComponent,
} from '@services/index';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ErrorInterceptor, JwtInterceptor } from './_helpers';
import { appInitializer, baseApiUrlFactory } from './_helpers/appInitializer';
import { PendingChangesGuard } from './_helpers/pending-changes.guard';
import { AuthenticationService } from './_services/_authentication.service';
import { GooglePlacesModule } from './admin/views/google-places/google-places.module';
import { NavigateBackModule } from './admin/views/navigateBack/navigateBack.module';
import { AngularMaterialModule } from './angular-material.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ApplyComponent } from './apply/apply.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { HeaderComponent } from './header/header.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { OnboardingComponent } from './onboarding/onboarding.component';
import { RedirectComponent } from './redirect/redirect.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { AccountSelectorModule } from './shared/components/account-selector/account-selector.module';
import { SpinnerComponent } from './spinner/spinner.component';
import { TenantComponent } from './tenant/tenant.component';

@NgModule({
  imports: [
    GooglePlacesModule,
    NavigateBackModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    AngularMaterialModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgbModule,
    ImageCropperModule,
    AccountSelectorModule,
  ],
  declarations: [
    AppComponent,
    LoginComponent,
    HeaderComponent,
    RedirectComponent,
    ApplyComponent,
    SpinnerComponent,
    ToastComponent,
    TenantComponent,
    HomeComponent,
    HttpSpinnerComponent,
    OnboardingComponent,
    ResetPasswordComponent,
    LogoutComponent,
    ForgotPasswordComponent,
  ],
  providers: [
    PendingChangesGuard,
    DialogService,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      deps: [
        EnvConfigurationService,
        AuthenticationService,
        AccountSelectorService
      ],
      multi: true,
    },
    {
      provide: LmsApi.API_BASE_URL,
      useFactory: baseApiUrlFactory,
      deps: [EnvConfigurationService],
    },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
